module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Bengali.5c31ebfe.jpg";